import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, HelpCircle, X } from 'lucide-react';

export default function FloatingButtons() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="floating-buttons" data-testid="floating-buttons">
      {/* Expanded menu */}
      <div 
        className={`flex flex-col gap-3 transition-all duration-300 ${
          isExpanded 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        {/* Call button */}
        <a 
          href="tel:+917300677651"
          className="group relative w-14 h-14 rounded-full bg-cyan-500 hover:bg-cyan-400 flex items-center justify-center shadow-lg hover:shadow-[0_0_20px_rgba(0,212,255,0.6)] transition-all duration-300"
          data-testid="floating-call-btn"
        >
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            <span className="bg-[#121212] text-white text-sm px-3 py-2 rounded-lg border border-white/10">
              Call Now
            </span>
          </div>
          <Phone className="w-6 h-6 text-black" />
        </a>
        
        {/* WhatsApp button */}
        <a 
          href="https://wa.me/917300677651"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative w-14 h-14 rounded-full bg-green-500 hover:bg-green-400 flex items-center justify-center shadow-lg hover:shadow-[0_0_20px_rgba(34,197,94,0.6)] transition-all duration-300"
          data-testid="floating-whatsapp-btn"
        >
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            <span className="bg-[#121212] text-white text-sm px-3 py-2 rounded-lg border border-white/10">
              WhatsApp
            </span>
          </div>
          <MessageCircle className="w-6 h-6 text-white" />
        </a>
        
        {/* Enquire button */}
        <div
          onClick={() => {
            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            setIsExpanded(false);
          }}
          className="group relative w-14 h-14 rounded-full bg-amber-500 hover:bg-amber-400 flex items-center justify-center shadow-lg hover:shadow-[0_0_20px_rgba(245,158,11,0.6)] transition-all duration-300 cursor-pointer"
          data-testid="floating-enquire-btn"
        >
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            <span className="bg-[#121212] text-white text-sm px-3 py-2 rounded-lg border border-white/10">
              Get Quote
            </span>
          </div>
          <HelpCircle className="w-6 h-6 text-black" />
        </div>
      </div>
      
      {/* Toggle button */}
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className={`w-16 h-16 rounded-full shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer ${
          isExpanded 
            ? 'bg-[#121212] border-2 border-cyan-500/50' 
            : 'bg-cyan-500 pulse-glow'
        }`}
        data-testid="floating-toggle-btn"
      >
        {isExpanded ? (
          <X className="w-7 h-7 text-cyan-400" />
        ) : (
          <MessageCircle className="w-7 h-7 text-black" />
        )}
      </div>
    </div>
  );
}
